if(!customElements.get('card-310')) {
    customElements.define('card-310', class Card310 extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        init() {
            this.select = this.querySelector('select');
            
            this.hiddenIdInputs = this.querySelectorAll('input[type="hidden"][name="id"]');
            this.hiddenSellingPlanInput = this.querySelector('input[type="hidden"][name="selling_plan"]');

            this.subscriptionButton = this.querySelector('.card-310__product-form--subscribe');
            this.priceContainer = this.querySelector('.card-310__price-container');
            this.pricePerServingContainer = this.querySelector('.card-310__price-serving');

            this.handleVariantChange = this.handleVariantChange.bind(this);

            this.select?.addEventListener('change', (e) => {
                this.handleVariantChange(e);
            });
        }

        handleVariantChange(e) {
            const selectedOption = [...e.target.options].find(option => option.selected);
            
            // update hidden inputs
            this.hiddenIdInputs?.forEach(input => {
                input.value = e.target.value;
            });

            // update price container
            this.priceContainer.innerHTML = selectedOption.dataset.price;

            // update subscription button
            if(this.subscriptionButton) {
                this.subscriptionButton.querySelector('.sub-discounted-price').innerHTML = selectedOption.dataset.subDiscountedPrice;
            }

            // update price per serving container
            this.pricePerServingContainer.innerHTML = selectedOption.dataset?.pricePerServing || '';
        }
    });
}